// extracted by mini-css-extract-plugin
export default {"signature":"app__css__app-pages-SelfHelp-checkInApplication-__index__signature"};